import broadcasting from "../services/engagement.broadcasting";
import targetSegment from "../services/customer.target.segment";
import notification from "../services/notification";
import auth from "../services/auth";
import authWithMerchantUuid from "./auth";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        broadcasts: [],
        broadcast: {},
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        searchableFields: [],
        targetSegmentOptions: [],
        defaultSelectedSearchOption: null,
        notification: null,
        form: {},
        action: null,
        activeBroadcastUuid: null,
        initializing: false,
        creating: true,
        sms: 0,
        monthlySms: 0,
        short_code: null,
        summaryCount: {},
        currentLastItem: 0,
        currentFirstItem: 0,
        initialPageCount: 0,
        totalPerPage: 0
    },
    mutations: {
        loading(state, value) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        broadcasts(state, broadcasts) {
            state.broadcasts = broadcasts;
            state.loading = false;
        },
        pagination(state, pagination) {
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.totalPerPage = pagination.list.length;
            state.currentFirstItem =
                state.totalPerPage > 0
                    ? state.initialPageCount *
                            state.prevPage +
                        1
                    : 0;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem +
                        state.totalPerPage -
                        1
                    : 0;
        },
        searchableFields(state, fields) {
            state.searchableFields = fields;
            state.defaultSelectedSearchOption = fields[0].value;
        },
        targetSegmentOptions(state, options) {
            state.targetSegmentOptions = options;
        },
        broadcast(state, broadcast) {
            state.broadcast = broadcast;
            state.initializing = false;
        },
        initializedForm(state, form) {
            state.form = form;
        },
        activeBroadcastUuid(state, uuid) {
            state.activeBroadcastUuid = uuid;
        },
        action(state, action) {
            state.action = action;
        },
        initializing(state) {
            state.initializing = true;
        },
        creating(state, value) {
            state.creating = value;
        },
        updateList(state, value) {
            state.broadcasts.unshift(value);
        },
        updateSmsCount(state, value) {
            state.sms = value;
        },
        updateMonthlySmsCount(state, value) {
            state.monthlySms = value;
        },
        setShortCode(state, code) {
            console.log({
                short_code: code
            });
            state.short_code = code;
        },
        setSummaryCount(state, summaryCount) {
            state.summaryCount = summaryCount;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        }
    },
    getters: {
        targetSegmentOptions: state => state.targetSegmentOptions,
        errors: state => state.errors,
        broadcast: state => state.broadcast,
        loading: state => state.loading
    },
    actions: {
        async getBroadcasts({ commit, state }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await broadcasting.getBroadcasts(param);
                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }
                commit("broadcasts", response.list);

                let merchant_detail = authWithMerchantUuid;
                let list = [];
                let target = 'rush';

                if (merchant_detail.state.planId === 5) {
                    target = 'zrewards';
                } else if (merchant_detail.state.user.merchant_uuid === 'zeal') {
                    target = 'zpoints';
                }


                for (let index = 0; index < response.list.length; index++) {
                    const element = response.list[index];
                    let notificationCountPerBroadcast = await broadcasting.getNotificationCountPerBroadcast(element.uuid);
                    let smsCountPerBroadcast = await broadcasting.getSmsCountPerBroadcast(element.uuid);

                    let paramForTargetSegmentCount = {
                        payload: {
                            target_segment_uuid: response.list[index].target_segment_uuid,
                            merchant_uuid: merchant_detail.state.user.merchant_uuid,
                            target: target
                        }
                    };

                    let targetSegmentCount = await targetSegment.getTargetSegmentCount(paramForTargetSegmentCount);
                    const broadcastType = response.list[index].type;
                    
                    list.push({
                        reference_number: response.list[index].reference_number,
                        title: response.list[index].title,
                        type: response.list[index].type,
                        successful_push_notif: notificationCountPerBroadcast.data,
                        failed_push_notif: broadcastType.includes('push') ? Math.abs(notificationCountPerBroadcast.data - targetSegmentCount.result.count) : 0,
                        customer_count: targetSegmentCount.result.count,
                        successful_sms: smsCountPerBroadcast.data.success,
                        failed_sms: smsCountPerBroadcast.data.failed,
                        published: response.list[index].published,
                        scheduled_time: response.list[index].scheduled_time,
                        created_at: response.list[index].created_at,
                        uuid: response.list[index].uuid
                    });
                }

                commit("broadcasts", list);
                commit("pagination", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async createBroadcast({ commit }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await broadcasting.createBroadcast(param);
                commit("updateList", response.broadcast);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot create broadcast.");
            } finally {
                commit("loading", false);
            }
        },
        async updateBroadcast({ commit, state }, param) {
            commit("loading", true);
            commit("errors", null);
            notification.info("Updating target segment.");
            try {
                let response = await broadcasting.updateBroadcast(
                    param,
                    state.activeBroadcastUuid
                );
                // let index = _.findIndex(state.broadcasts, function(row) {
                //     return row.uuid === state.activeBroadcastUuid;
                // });
                // _.forEach(response.broadcast, function(value, key) {
                //     state.broadcasts[index][key] = value;
                // });
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot update broadcast.");
            } finally {
                commit("loading", false);
            }
        },
        async getTargetSegmentOptions({ commit }) {
            commit("errors", null);
            try {
                let response = await broadcasting.getTargetSegmentOptions();
                let audienceOptions = [
                    {
                        text: "All Audience",
                        value: "default"
                    }
                ];

                if (auth.merchantUuid() == '90e55e23-8bf6-457d-8d8c-c3d0f21afdcb') {
                    audienceOptions.push({
                        text: "SPAVI Test Broadcast",
                        value: "test-spavi"
                    });
                }

                _.forEach(response.options, function(value) {
                    audienceOptions.push({
                        text: value.name,
                        value: value.target_segment_uuid
                    });
                });
                commit("targetSegmentOptions", audienceOptions);
                return response;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getSearchableFields({ commit }) {
            commit("errors", null);
            try {
                let response = await broadcasting.getSearchableFields();
                let searchableFields = [];
                _.forEach(response.searchable_fields, function(value, key) {
                    searchableFields.push({ text: value, value: key });
                });
                commit("searchableFields", searchableFields);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async visibility({ commit, state }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await broadcasting.visibility(
                    param.apiFields,
                    param.uuid
                );
                state.broadcasts[param.index].visibility =
                    param.apiFields.visibility;
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async delete({ commit, state }, param) {
            commit("loading", true);
            commit("errors", null);
            try {
                let response = await broadcasting.delete(param);
                let index = _.findIndex(state.broadcasts, function(row) {
                    return row.uuid === param;
                });
                state.broadcasts.splice(index, 1);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async viewBroadcast({ commit, state }, uuid = null) {
            commit("loading", true);
            commit("initializing");
            commit("errors", null);
            try {
                let response = await broadcasting.view(uuid ? uuid : state.activeBroadcastUuid)
                commit("broadcast", response);
                return response;
            } catch (errors) {
                state.initializing = false;
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async initializedForm({ commit }, form) {

            commit("initializedForm", form);
        },
        async resetForm({ commit, dispatch, state }, form) {
            try {
                if (state.targetSegmentOptions.length < 1) {
                    await dispatch("getTargetSegmentOptions");
                }
                let merchant_detail = await auth.getMerchantDetail();
                form.smsDescription = 'To unsubscribed to this Loyalty Program, Send "STOP" to ' + merchant_detail.short_code + '/' + merchant_detail.crosstelco_shortcode;
                form.audienceOptions = state.targetSegmentOptions;
                if ("sms_message" in form) {
                    form.sms_message = `To unsubscribed to this Loyalty Program, Send "STOP" to ${merchant_detail.short_code}/${merchant_detail.crosstelco_shortcode}`;
                }
                commit("initializedForm", form);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async smsCount({ commit, state }) {
            try {
                let response = await broadcasting.getSmsCount();
                commit("updateSmsCount", response.count);
            } catch (errors) {
                commit("errors", errors);
                state.loading = false;
            }
        },
        async monthlySmsCount({ commit, state }) {
            try {
                let response = await broadcasting.getMonthlySmsCount();
                commit("updateMonthlySmsCount", response.count);
            } catch (errors) {
                commit("errors", errors);
                state.loading = false;
            }
        },
        async getSummaryCount({ commit }, params = {}) {
            try {
                let response = await broadcasting.getSummaryCount(params);
                commit("setSummaryCount", response.data);
            } catch (errors) {
                console.log(errors);
            }
        }
    }
};
